import React, { Component } from 'react';
import {
  withRouter
} from 'react-router-dom';
import { Button } from '@betareader/design-system';

// i18n
import { withTranslation } from 'react-i18next';

// redux
import { push } from '../../navigation';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

export class SubMenu extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const {
      items, location, changePage
    } = this.props;
    if (!items || items.length === 0) return null;
    return (
      <nav aria-label='Book submenu' style={{ display: 'grid', gap: 'var(--br-space-1)', padding: 'var(--br-space-1)' }}>
        {
          items && items.map((item) => {
            if (!item) return null;
            return (
              <Button
                variant='ghost'
                key={item.key}
                style={{ textAlign: 'left', justifyContent: 'flex-start' }}
                aria-current={location.pathname === item.path ? 'page' : undefined}
                onClick={() => changePage(item.path)}
              >{item.name}</Button>
            );
          })
        }
      </nav>
    );
  }
}


// redux stuff
const mapStateToProps = state => ({
  user: state.user.user,
  idToken: state.user.idToken,
  currentBook: state.book.currentBook
});

const mapDispatchToProps = dispatch => bindActionCreators({
  changePage: newPage => push(newPage)
}, dispatch);

export default withTranslation()(withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(SubMenu)));
